import base from '../../base-entity'

export default base('gear')
